var x, i, j, l, ll, selElmnt, a, b, c
/* Look for any elements with the class "custom-select": */
x = document.getElementsByClassName('custom-select')
l = x.length
for (i = 0; i < l; i++) {
  selElmnt = x[i].getElementsByTagName('select')[0]
  ll = selElmnt.length
  /* For each element, create a new DIV that will act as the selected item: */
  a = document.createElement('DIV')
  a.setAttribute('class', 'select-selected placeholder')
  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML
  x[i].appendChild(a)
  /* For each element, create a new DIV that will contain the option list: */
  b = document.createElement('DIV')

  b.setAttribute('class', 'select-items select-hide')
  for (j = 1; j < ll; j++) {
    /* For each option in the original select element,
    create a new DIV that will act as an option item: */
    c = document.createElement('DIV')
    c.innerHTML = selElmnt.options[j].innerHTML
    c.addEventListener('click', function (e) {
      const target = this.parentNode
      if (target) {
        const targetSibling = target.previousSibling as HTMLElement
        targetSibling ? targetSibling.classList.remove('placeholder') : null
      }
      /* When an item is clicked, update the original select box,
      and the selected item: */
      var sameAsSelected,
        i,
        k,
        select,
        holder,
        selectLength,
        sameAsSelectedLength
      select = this.parentNode?.parentNode as HTMLElement
      if (select) {
        select = select.getElementsByTagName('select')[0]
      }
      selectLength = select.length
      holder = this.parentNode?.previousSibling as HTMLElement

      for (i = 0; i < selectLength; i++) {
        if (select.options[i].innerHTML == this.innerHTML) {
          select.selectedIndex = i
          holder.innerHTML = this.innerHTML
          sameAsSelected = this.parentNode as HTMLElement
          if (sameAsSelected) {
            sameAsSelected =
              sameAsSelected.getElementsByClassName('same-as-selected')
          }
          sameAsSelectedLength = sameAsSelected.length
          for (k = 0; k < sameAsSelectedLength; k++) {
            sameAsSelected[k].removeAttribute('class')
          }
          this.setAttribute('class', 'same-as-selected')
          break
        }
      }
      holder.click()
    })
    b.appendChild(c)
  }
  x[i].appendChild(b)
  a.addEventListener('click', function (e) {
    /* When the select box is clicked, close any other select boxes,
    and open/close the current select box: */
    e.stopPropagation()
    closeAllSelect(this)
    let thisElementSibling = this.nextSibling as HTMLElement
    let thisElementPreviousElementSibling = this.previousSibling as HTMLElement
    if (thisElementSibling) {
      thisElementSibling.classList.toggle('select-hide')
    }
    if (thisElementPreviousElementSibling) {
      thisElementPreviousElementSibling.classList.toggle('select-arrow-active')
    }
  })
}

const closeAllSelect = (elmnt?: HTMLElement) => {
  /* A function that will close all select boxes in the document,
  except the current select box: */
  var x,
    y,
    i,
    xl,
    yl,
    arrNo = []
  x = document.getElementsByClassName('select-items')
  y = document.getElementsByClassName('select-selected')
  xl = x.length
  yl = y.length
  for (i = 0; i < yl; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i)
    } else {
      document
        .querySelectorAll('.dropdown-chevron')
        .forEach((element) => element.classList.remove('select-arrow-active'))
    }
  }
  for (i = 0; i < xl; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add('select-hide')
    }
  }
}

/* If the user clicks anywhere outside the select box,
then close all select boxes: */
document.addEventListener('click', (e: Event) => {
  closeAllSelect()
})
